/*
 * Title: Rewards/RedeemContent.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: Redeem Content page content listing, click on list popup will shows from bottom.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import React, { useState, Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import Buttonlink from "@components/Button";
import LinkTo from "@components/LinkTo";
import Icon from "@components/Icon";
import { numberFormat } from "@helpers/common";
import Logo from "@components/Logo";
import close from "@assets/close.png";
import reward_collected from "@assets/reward_collected.gif";
import { NavLink } from "react-router-dom";
import Api from "@services/api";
import Loader from "@components/Loader";
import NotificationService from "@services/notification-service";
import { connect } from "react-redux";
import moment from "moment";
import { calculateRedumptionTiime } from "@helpers/common";

type Props = {};
type MyState = {
  toggleHeight: boolean;
  isOpen: boolean;
  isRewardOpen: boolean;
  loader: boolean;
};
class RedeemContentItem extends React.Component<Props | any, MyState> {
  state: MyState = {
    toggleHeight: false,
    isOpen: false,
    isRewardOpen: false,
    loader: false,
  };

  toggleHandler = (redeemed) => {
    if (!redeemed) {
      this.setState({ toggleHeight: !this.state.toggleHeight });
    }
  };

  openModal = () => {
    this.setState({ isOpen: true });
  };

  closeModal = () => {
    this.setState({ isOpen: false });
  };

  closeRewardModal = () => {
    this.setState({ isRewardOpen: false });
  };

  openRewardModal = () => {
    this.setState({ isRewardOpen: true, isOpen: false });
    document.documentElement.style.removeProperty("overflow");
    setTimeout(() => {
      this.setState({ isRewardOpen: false });
      if (typeof this.props.fetch === "function") {
        this.props.fetch();
      }
    }, 3000);
  };

  purchaseRadeemPoint = async () => {
    this.setState({ loader: true });
    const { reward } = this.props.item;
    const data = {
      rewardId: reward?.id,
      fanId: this.props.user.id,
      programId: this.props.creator.program?.id,
      points: reward?.points,
      title: reward?.title,
    };
    const json = await Api.submitFanRedemptions(data);
    if (json.status == 201) {
      this.setState({ toggleHeight: false });
      this.closeModal();
      //this.openRewardModal();
    } else {
      NotificationService.error(json?.data?.error?.message);
    }
    this.setState({ loader: false });
  };

  render() {
    let { item, points_redeemed, creator, user } = this.props;
    let numRedemptions = item.numRedemptions;

    const config = calculateRedumptionTiime(
      item.reward,
      item?.lastRedemption,
      numRedemptions,
      item.reward?.totalRedemptions,
      points_redeemed
    );

    item = item.reward;

    let redeemed = config?.isRedeemed;
    let isDisabled = config?.isDisabled;

    const cname = creator.creator?.username;
    const pname = creator.program?.name;

    return (
      <div
        className={`${
          this.state.toggleHeight
            ? "max-h-[100vh] ease-in-out duration-1000"
            : "max-h-[103px] ease-in-out duration-700"
        } bg-tile p-[20px] transition-all rounded-[10px] relative cursor-pointer overflow-hidden`}
      >
        <div
          onClick={() => this.toggleHandler(redeemed)}
          className="absolute inset-0 z-10"
        />
        {/* pills  */}
        <div className="flex flex-col justify-center">
          <div className="flex items-center justify-between">
            <div className="flex flex-wrap items-center gap-x-2">
              {redeemed ? (
                <div className="bg-body opacity-50 px-[8px] h-[30px] rounded-full flex items-center justify-center">
                  <p className="tile-inlay-primary opacity-50 lg:text-[14px] text-[12px] uppercase font-semibold tracking-wider">
                    Redeemed
                  </p>
                </div>
              ) : (
                <>
                  <div className="bg-body px-[8px] h-[30px] rounded-full flex items-center justify-center">
                    <p data-testid="itempoints" className="green lg:text-[14px] text-[12px] uppercase font-semibold tracking-wider">
                      {/* {numberFormat(item.price)} fans */}
                      {item.points}
                    </p>
                  </div>
                  {numRedemptions > 0 && (
                    <div className="bg-body opacity-50 px-[8px] h-[30px] rounded-full flex items-center justify-center">
                      <p className="tile-inlay-primary opacity-50  lg:text-[14px] text-[12px] uppercase font-semibold tracking-wider">
                        Redeemed {numRedemptions}x
                      </p>
                    </div>
                  )}
                </>
              )}

              {/* {this.props.item.redeemed && (
              <div className="bg-[#000]/50 p-[8px] rounded-full flex items-center justify-center">
                <p className="green lg:text-[14px] text-[12px] uppercase font-normal tracking-wider">
                  REDEEMED {this.props.item.redeemed}X
                </p>
              </div>
            )} */}
            </div>
            {/* <Icon icon={item.touchpoints} /> */}
            {/* <Logo
							logo_letter="true"
							className="max-h-[40px] h-full w-[auto] object-contain rounded-full"
						/> */}
          </div>
          <h4 className="font-medium tile-inlay-primary lg:text-[20px] text-[18px] min-h-[30px] mt-[10px]">
            {item.title}
          </h4>
        </div>
        {/* expanded  */}
        <p
          className={`${
            this.state.toggleHeight ? null : "truncate"
          } tile-inlay-primary text-[16px] font-normal tracking-wider mt-[10px]`}
        >
          {item.description}
        </p>
        <div
          className={`${
            this.state.toggleHeight ? "opacity-100" : "opacity-0"
          } duration-700 ease-in-out transition-opacity`}
        >
          {/* <div className="flex items-center gap-x-1">
                      <img
                        src={usercheck}
                        alt="{reward.fans} FANS REDEEMED THIS"
                        className="h-6"
                      />
                      <p className="primary lg:text-[16px] text-[14px] font-normal">
                        {reward.fans} FANS REDEEMED THIS
                      </p>
                    </div> */}
        </div>
        <div className="divide-y h-[1px] w-full bg-gray-600 my-[20px] bg-opacity-40" />
        <div className="text-center z-20 relative">
          <Buttonlink
            disabled={isDisabled}
            text="redeem"
            onClick={this.openModal}
            className={`font-medium bg-btn ${
              isDisabled && "disabled:bg-[#616161]"
            } rounded-full btn-inlay-primary w-full max-w-[300px] mx-auto py-2.5 opacity-80`}
          />
          {config?.isPurchase ? (
            <div className="text-center mt-[15px]">
              {/* <p className="text-primary">
								You need {item.price - points_redeemed} more fans
							</p> */}
              <NavLink to={`/${cname}/${pname}/earn`}>
                <div className="font-medium uppercase tile-inlay-primary hover:opacity-80">
                  Earn Now
                </div>
              </NavLink>
            </div>
          ) : (
            !!config?.humanize && (
              <p className="text-[14px] leading-[14px] font-normal text-[#44CD51] text-center mt-[10px]">
                available again in {config?.humanize}
              </p>
            )
          )}

          <Transition appear data-testid="redeempopup" show={this.state.isOpen} as={Fragment}>
            <Dialog
              as="div"
              className="relative z-50"
              onClose={this.closeModal}
            >
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-black bg-opacity-[0.85]" />
              </Transition.Child>

              <div className={`fixed inset-0`}>
                <div className="flex items-end justify-center min-h-full text-center">
                  <Transition.Child
                    as={Fragment}
                    enter="transform transition ease-in-out duration-700"
                    enterFrom="translate-y-full"
                    enterTo="translate-y-0"
                    leave="transform transition ease-in-out duration-700"
                    leaveFrom="translate-y-0"
                    leaveTo="translate-y-full"
                  >
                    <Dialog.Panel className="w-screen max-w-[685px] transform overflow-hidden rounded-b-none rounded-t-[40px] text-left align-middle shadow-xl transition-all bg-tile">
                      <div className="relative">
                        <button
                          type="button"
                          onClick={this.closeModal}
                        >
                          <span className="sr-only">Close panel</span>
                          <div className="w-[25px] h-1 absolute mx-auto top-[10px] left-0 right-0 bottom-0 rounded-full bg-lightBlack"></div>
                          {/* <svg className="w-8 h-8 text-red-500 absolute mx-auto top-[10px] left-0 right-0 bottom-0"  width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">  <path stroke="none" d="M0 0h24v24H0z"/>  <line x1="18" y1="6" x2="6" y2="18" />  <line x1="6" y1="6" x2="18" y2="18" /></svg> */}
                        </button>
                      </div>
                      <div className="px-[30px] text-center">
                        <h3 className="tile-inlay-primary font-[550] text-[24px] leading-[31px] mt-[41px]">
                          Are you sure you want to redeem this reward?
                        </h3>
                        <p className="mt-[15px] text-[18px] font-normal leading-[22px] tile-inlay-primary">
                          Once redeemed, {item.points} points will be deducted
                          from your available points. We’ll email you shortly
                          with instructions to collect your prize.
                        </p>
                        <div className="relative">
                          <Buttonlink
                            text={!this.state.loader && "redeem now"}
                            suffix={
                              this.state.loader && (
                                <Loader height={30} width={30} white={true} />
                              )
                            }
                            onClick={this.purchaseRadeemPoint}
                            className="font-medium bg-btn rounded-full btn-inlay-primary w-full max-w-[300px] mx-auto h-[41px] flex items-center justify-center opacity-80 my-[50px]"
                          />
                        </div>
                      </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </Dialog>
          </Transition>
          <Transition appear show={this.state.isRewardOpen} as={Fragment}>
            <Dialog
              as="div"
              className="relative z-50"
              onClose={this.closeRewardModal}
            >
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-black bg-opacity-[.85]" />
              </Transition.Child>

              <div className={`fixed inset-x-0 top-0`}>
                <div className="flex items-center justify-center min-h-full text-center">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 scale-95"
                    enterTo="opacity-100 scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 scale-100"
                    leaveTo="opacity-0 scale-95"
                  >
                    <Dialog.Panel className="w-screen max-w-[685px] h-screen transform overflow-hidden bg-tile">
                      <div className="relative">
                        <button
                          type="button"
                          className="text-white rounded-md outline-none hover:text-white hover:opacity-70"
                          onClick={this.closeRewardModal}
                        >
                          <span className="sr-only">Close panel</span>
                          <svg
                            className="w-8 h-8 text-red-500 absolute top-3 right-3"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            strokeWidth="2"
                            stroke="currentColor"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            {" "}
                            <path stroke="none" d="M0 0h24v24H0z" />{" "}
                            <line x1="18" y1="6" x2="6" y2="18" />{" "}
                            <line x1="6" y1="6" x2="18" y2="18" />
                          </svg>
                        </button>
                      </div>
                      <div className="px-[30px] text-center">
                        <img
                          src={reward_collected}
                          alt="Reward collected"
                          className="max-w-[385px] w-full mx-auto"
                        />
                        <h3 className="tile-inlay-primary font-semibold text-[24px] leading-[31.2px] -mt-[40px]">
                          You redeemed a reward!
                        </h3>
                        <p className="mt-[15px] text-[18px] font-normal leading-[21.6px] tile-inlay-primary opacity-70 mb-[40px]">
                          See a recap of your prize below, and check your email
                          soon for all the info you’ll need to complete your
                          pickup.
                        </p>
                        <div className="bg-tile p-[20px] transition-all rounded-[10px] relative text-left">
                          <div className="bg-body/50 px-[8px] h-[30px] rounded-full inline-flex items-center">
                            <p className="tile-inlay-primary lg:text-[14px] text-[12px] uppercase font-normal tracking-wider">
                              {item.points} fans
                            </p>
                          </div>
                          <h4 className="font-medium tile-inlay-primary text-[18px] leading-[22.5px] mt-[10px]">
                            {item.title}
                          </h4>
                        </div>
                      </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </Dialog>
          </Transition>
        </div>
        <div>
          {/* <p className="lightBlack lg:text-[16px] text-[14px] uppercase font-normal tracking-wider text-center">
                      You need {reward.more_points} more points.
                    </p> */}
          {/* <div className="text-center mt-[15px]">
						<LinkTo
							to="/my-rewards"
							text="Earn Now"
							className="font-medium uppercase primary hover:opacity-80"
						/>
					</div> */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ creator }) => {
  return {
    creator: creator,
  };
};

export default connect(mapStateToProps)(RedeemContentItem);
